import { months, weekdays } from '../strings.en';

export default {
  tabSE: 'DeliveryPortal Sweden',
  tabFI: 'DeliveryPortal Finland',
  ordersOverview: {
    modalHeader: 'Orders overview',
    formFilterHeader: 'Filter',
    formFilterOrdersHeader: 'Filter orders',
    filterInputPlaceholder: 'Search for address',
    mapMenuButton: 'Orders overview',
    importPlannedDates: 'Import Planned Dates',
    importSuccess: 'Updated planned dates in report',
    importError: 'Import failed. Try again',
    downloadExcel: 'Download Excel',
    downloadSuccess: 'Excel file downloaded',
    downloadError: 'Excel file could not be downloaded.',
    downloadPdfStarted:
      'Generating PDF for {address}. PDF generation may take a while depending on the report size.',
    downloadPdfSuccess: 'PDF downloaded successfully',
    downloadPdf429Title: 'Please wait',
    downloadPdfError429:
      'PDF generation is busy, please wait a moment and try again.',
    downloadPdfErrorGeneric: 'Failed to generate PDF, please try again.',
    downloadPdfCancelled:
      'PDF download was cancelled because the table was closed.',
    filterOptions: {
      showAll: 'Show all',
      incomplete: 'Show incomplete',
      complete: 'Show complete',
    },
    tableHeaders: {
      address: 'Property Address',
      customerType: 'Type',
      customerName: 'Customer name',
      completedDate: 'Completed date',
      latestStatus: 'Latest status',
      statusDate: 'Status date',
      netAdminId: 'NetAdmin ID',
      customerInstallationDate: 'Installation date',
      pdf: 'PDF',
      planedInstallationDate: 'Planned installation',
      bookedCustomerInstallationDate: 'Booked installation',
      siteProjectPlanningExecutedDate: 'Site project planning executed',
      siteShaftBooked: 'Site shaft booked',
      siteShaftInstallationDate: 'Site shaft installation',
      fiberCableInstalledForCustomer: 'Fiber cable installed',
      fiberReceiverInstallationDate: 'Fiber receiver installation',
      plotDesignDate: 'Plot Design',
      preinstallationDate: 'Preinstallation',
      plotExcavationDate: 'Plot Excavation',
      ductConnection: 'Duct Connection',
      cableBlowingDate: 'Cable Blowing',
      splicingAndMeasuringDate: 'Splicing & Measuring',
      splicingAndMeassuringDate: 'Splicing & Measuring',
      splicingDate: 'Splicing',
      commissioningDate: 'Commissioning',
      measuringDate: 'Measuring',
      macAddress: 'MAC-address CPE',
      macNetAdminId: 'MAC & NetAdmin ID',
      buildingName: 'Building name',
      buildingId: 'Building ID',
      deliveryPoints: 'Delivery Points (delivered/total)',
    },
    error: 'Could not load any orders, please try again later.',
    latestStatus: {
      ORDERED: 'Ordered',
      ORDERED_FOR_BUILD: 'Ordered for build',
      CANCELLED: 'Cancelled',
      REVOKED: 'Revoked',
      WITHDRAWN: 'Withdrawn',
      ESCALATED: 'Escalated',
      CONSTRUCTION_DEVIATION: 'Constructural deviation',
      NOT_VALIDATED: 'Not validated',
      WARNING: 'Warning',
      INSTALLED: 'Installed',
      UNKNOWN: 'Unknown',
    },
    status: 'Status',
    reportDetails: {
      false: 'No',
      true: 'Yes',
      deliveryPoints: 'Delivery points',
      itemPerPage: 'Items per page',
      labels: {
        address: 'Property address',
        propertyDesignation: 'Property designation',
        deliveryContact: 'Delivery contact',
        phone: 'Phone number',
        email: 'Email',
        housingNetwork: 'Housing network',
        netType: 'Net type',
        propertyConnection: 'Property connection',
        connectionType: 'Connection type',
        propertyNetwork: 'Property network',
      },
      propertyNetwork: {
        EXISTING: 'Existing',
        CONSTRUCTION: 'Construction',
      },
      networkType: {
        OWN_NETWORK: 'Own network',
        KO: 'Communication Operator',
        ACQUIRED: 'Accepted',
        RENTAL: 'Rental',
      },
      connectionType: {
        ONGOING_CONSTRUCTION_AREA: 'Ongoing construction area',
        EXISTING: 'Existing',
        RENT: 'Rent',
        KO: 'Communication Operator',
      },
      constructionType: {
        HANDED_TO_CONSTRUCTION: 'Handed to construction',
        STARTED: 'Started',
        FINISHED: 'Finished',
        OBSTRUCTION: 'Obstruction',
        PLANNED: 'Planned',
        MIGRATION_ONGOING: 'Migration ongoing',
        MIGRATED: 'Migrated',
      },
      constructionStatus: {
        utbyggnad: 'Expansion',
        HANDED_TO_CONSTRUCTION: 'Handed to construction',
        STARTED: 'Started',
        FINISHED: 'Finished',
        OBSTRUCTION: 'Obstruction',
        PLANNED: 'Planned',
        MIGRATION_ONGOING: 'Migration ongoing',
        MIGRATED: 'Migrated',
      },
    },
    deliveryPointsTable: {
      mac: 'MAC',
      id: 'ID',
    },
  },
  installationReport: {
    popUpBtnText: 'Progress planning',
    header: 'Progress planning',
    saveBtn: 'Save report',
    dismissBtn: 'Close',
    addressLabel: 'Address',
    toOrdersModal: 'To orders overview',
    confirmModal: {
      header: 'Are you sure you want to close the form?',
      text: 'There are unsaved changes. Make sure to save them before closing modal.',
      cancelBtn: 'Take me back to the report',
      closeBtn: 'Yes, close!',
    },
    missingIdMessage: 'Progress planning report id is missing (sourceKey)',
    saveSuccessMessage: 'Progress planning report saved successfully',
    saveErrorMessage:
      'Could not save the progress planning report. Please try again.',
    failToLoadMessage: {
      403: 'Access denied, please log in to view progress planning report.',
      404: 'No progress planning report available for selected residence.',
      408: 'Request Timeout. Please reload the application.',
      500: 'Server problems, please try again later.',
      general: 'Could not load the progress planning report.',
    },
    errorText: 'Could not load report. Please refresh or try again later.',
    form: {
      planedInstallationDate: 'Planned Installation Date',
      bookedCustomerInstallationDate: 'Booked Customer Installation Date',
      siteProjectPlanningExecutedDate: 'Site Project Planning Executed Date',
      siteShaftBooked: 'Site Shaft Booked',
      siteShaftInstallationDate: 'Site Shaft Installation Date',
      fiberCableInstalledForCustomer: 'Fiber Cable Installed For Customer',
      fiberReceiverInstallationDate: 'Fiber Receiver Installation Date',
      macAddress: 'MAC-address CPE',
      email: 'Email',
      name: 'Name',
      phoneNumber: 'Phone number',
    },
  },
  installationReportV2: {
    tabNames: {
      ORDER_OVERVIEW: 'Order Overview',
      PLOT_DESIGN: 'Plot Design',
      PLOT_EXCAVATION: 'Plot Excavation',
      DUCT_CONNECTION: 'Duct Connection',
      PRE_INSTALLATION: 'Preinstallation',
      CABLE_BLOWING: 'Cable Blowing',
      SPLICING_MEASURING: 'Splicing & Measuring',
      SPLICING: 'Splicing',
      COMMISSIONING: 'Commissioning',
      MEASURING: 'Measuring',
    },
    modal: {
      header: 'Installation Reporting',
      completedBy: 'Completed by #{user} #{date}',
      closeBtn: 'Close',
      saveBtn: 'Save',
      completeBtn: 'Complete report',
      unlockReportBtn: 'Unlock report',
      reportCompletedBtn: 'Report completed',
      reportCompletedDisabledTooltip:
        'Contact your construction responsible to have the report unlocked.',
      completeBtnDisabledTooltip:
        'The report can be completed once all phases are fully finished.',
      onProceedError: 'Form is not valid',
      cannotSaveNetAdmin: 'Cannot save NetAdmin value.',
    },
    completeConfirmation: {
      title: 'Complete report?',
      whatHappens: 'What happens if you confirm?',
      bulletInvoice:
        'The customer will be invoiced directly after confirmation.',
      bulletLocked: 'The entire report will be locked and cannot be changed.',
      checkboxLabel: 'I have read and understood the above text.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      completedTitle: 'Report completed!',
      completedBody:
        'Customer has been commissioned and invoice has been sent! This report is no longer editable.',
      closeWindow: 'Close this window',
    },
    plotDesignTab: {
      instructions: 'Fill in the information to complete.',
      completed: 'Plot Design - Completed!',
      plannedPlotDesign: 'Planned Plot Design',
      executedPlotDesign: 'Executed Plot Design',
      comment: 'Comment',
      awaitingSign: 'Awaiting sign',
      completedSign: 'Sign completed',
      initiateSign: 'Initiate sign',
    },
    plotExcavationTab: {
      instructions: 'Fill in the information to complete.',
      completed: 'Plot Excavation - Completed!',
      plannedPlotExcavation: 'Planned Plot Excavation',
      executedPlotExcavation: 'Executed Plot Excavation',
      comment: 'Comment',
    },
    ductConnectionTab: {
      instructions: 'Preform self-inspection to complete Duct Connetion!',
      completed: 'Duct Connected',
      executedDate: 'Executed date',
      notConnected: 'Not connected',
      comment: 'Comment',
    },
    orderOverviewTab: {
      markAsBom: 'Mark as BOM',
      bomTag: 'BOM',
      comment: 'Comment',
      commentPlaceholder: 'Comment...',
      save: 'Save',
      cancel: 'Cancel',
      undoBom: 'Undo BOM',
      markAsBomError: 'Could not mark the delivery point as BOM',
      undoBomError: 'Could not undo BOM for the delivery point',
      infoText:
        'Information about the selected order is shown below. Fill in the reports in the tabs above.',
      subHeader: 'Order Information',
      address: 'Address',
      customerName: 'Customer Name',
      email: 'Email',
      phoneNumber: 'Phone Number',
      connectionType: 'Connection Type',
      contactedDate: 'Customer Contacted',
      statusReport: 'Status of Report',
      customerType: 'Opportunity type',
      greenfieldIfs: 'Greenfield IFS',
      greenfieldProjectAccessDeniedHeading: 'Project access required',
      greenfieldProjectAccessDeniedMessage:
        'You do not have access to this project. Contact your administrator if you need access.',
      greenfieldProjectAccessDeniedClose: 'Close',
      doneTag: 'DONE',
    },
    preinstallationTab: {
      instructions: 'Fill in the information and preform the control.',
      completed: 'Preinstallation - Completed!',
      plannedPreinstallation: 'Planned Preinstallation',
      executedPreinstallation: 'Executed Preinstallation',
      macAddress: 'MAC-address CPE / Serial number',
      macAddressInputLabel:
        'MAC-address CPE (P2P) or Serial number ONT (XGS-PON)',
      help: 'Help',
      comment: 'Comment',
      netAdmin: 'NetAdmin',
      netAdminHeader: 'ONT / CPE Registration',
      netAdminSubHeader:
        'Select Device and fill in value below. Save to register!',
      deviceCategory: 'Device type',
      deviceValue: 'Device value',
      macSerialPlaceholder: 'MAC / Serial number',
      mustMatchFormat: 'Must match format:',
      netAdminStatus: {
        saveToUpload:
          'Fill in MAC-address CPE / Serial number and Save to upload!',
        notSaved: 'Not saved',
        cannotUpload:
          'Saved - but cannot upload without executed date and completed self-inspections.',
        clickSave: 'Click Save to upload to NetAdmin!',
        uploading: 'Sent to NetAdmin!',
        uploaded: 'Uploaded & Saved',
      },
      inputPlaceHolder: 'MAC-address CPE or Serial number',
      maxInput: 'Maximum 17 characters allowed.',
      incorrectFormat: 'Incorrect format, see Help for instructions.',
      snackbarInfo:
        'If you want to change the current value, please contact your Project Manager at GlobalConnect.',
      model: 'Model',
      selection: 'Selection',
    },
    splicingAndMeasuringTab: {
      instructions: 'Fill out the information and upload files!',
      completed: 'Splicing & Measuring - Completed!',
      plannedMeasuring: 'Planned Measuring',
      executedMeasuring: 'Executed Measuring',
      plannedSplicing: 'Planned Splicing',
      executedSplicing: 'Executed Splicing',
      fileAndImageUpload: 'File and image upload',
      upload: 'Upload',
      showImages: 'Show images',
      comment: 'Comment',
      commentDescriptionExplanation:
        'Please specify reason for not following panelcard.',
      fiberData: {
        title: 'Fiber Data',
        panelcard: {
          question: 'Has Panelcard been followed?',
          yes: 'Yes',
          no: 'No',
        },
        switchName: 'Switch name',
        switchPort: 'Switch port',
        switchCard: 'Switch card',
        odfInSite: 'ODF in Site',
        odfContact: 'ODF Contact',
        cabinet: 'FOC (Fiber Optic Cabinet)',
        cableIdCabinet: 'CableID in FOC',
        fiberInCabinet: 'Fiber in FOC',
        ductColorInCabinet: 'Ductcolor in FOC',
        splitterPort: 'Splitter Port',
        splitterName: 'Splitter Name',
        placeholders: {
          syntax: 'NNNN000-NN0',
          number: 'Number',
          focType: 'Type FOC',
          focCableId: 'Type Cable ID',
          color: 'Type duct color',
          name: 'Type name',
          select: 'Select',
        },
        descriptions: {
          switchNameSyntax: 'Suggested format NNNNN0000-NN0',
        },
      },
      toast: {
        notFollowingPanelcard:
          'Specify reason for not following panelcard in comment.',
      },
    },
    cableBlowingTab: {
      instructions: 'Fill in information to complete this moment.',
      completed: 'Cable Blowing - Completed!',
      plannedCableBlowing: 'Planned Cable Blowing',
      executedCableBlowing: 'Executed Cable Blowing',
      comment: 'Comment',
    },
    commissioningTab: {
      instructions: 'Fill in the information and perform control.',
      completed: 'Commissioning - Completed!',
      plannedCommissioning: 'Planned Commissioning',
      executedCommissioning: 'Executed Commissioning',
      plannedMeasuring: 'Planned Measuring',
      executedMeasuring: 'Executed Measuring',
      comment: 'Comment',
    },
    selfInspection: {
      markAsComplete: 'Mark as done',
      uploadImage: 'Upload image',
      showControlled: 'Show controlled',
      undoSelfInspection: 'Undo self inspection',
      handleImage: 'Handle images',
      showAttachments: 'Show attachments',
      updateSelfInspectionErrorMessage: 'Could not save self inspection',
      notApplicableText: 'Describe reason for not applicable',
      cancel: 'Cancel',
      markAsNonApplicable: 'Mark as non-applicable',
      notApplicable: 'Not-applicable',
      editNotApplicableComment: 'Edit description',
      saveChanges: 'Save changes',
      updateSelfInspectionSuccessMessage: 'Description is saved and updated',
      selfInspectionSavedSuccessMessage:
        'The self inspection was successfully saved',
      revertSelfInspectionMessage: 'Self inspection successfully reverted',
      updateSelfInspectionFilesMessage:
        'Self inspection files were successfully updated',
      updateSelfInspectionRevertedMessage:
        'Uploading of images were cancelled.',
      uploadSelfInspectionImageSuccess: 'Images uploaded!',
      uploadSelfInspectionImageError: 'Could not upload images. Try again!',
      deleteSelfinspectionImageSuccess: 'Image has been removed.',
      deleteSelfinspectionImageError: 'Could not remove image.',
      loadingImages: 'Loading images...',
      instructionalImage: {
        DepthExampleImage: 'Include ruler in photo - See example',
      },
      done: 'Done: ',
      na: 'N/A: ',
    },
    updateInstallationReportSuccess: 'Your changes have been saved',
    updateInstallationReportError: 'Your changes could not be saved',
    clearDate: 'Clear date',
    alerts: {
      executedDateAlert: 'Make sure all self-inspections are completed',
      signReady: 'Ready for sign-off',
    },
    imageChecklist: {
      title: 'Image checklist',
      listItems: {
        splicingOutlet: 'Image of splicing in fiber outlet/facade box',
        splicingFOS: 'Image of splicing in FOS',
        sealingDuctFOS: 'Image of sealing duct in FOS',
        hasOdfPortImage: 'Image of ODF port',
        hasSwitchPortImage: 'Image of Switchport',
        hasNodeImage: 'Before and after image in site',
      },
    },
  },
  macAddressInvalid: 'Invalid MAC-address',
  Huvudbyggnad: 'Main building',
  Extraanslutning_seperat_byggnad: 'Extra connection separate building',
  Extraanslutning_inom_huvudbyggnad:
    'Extra connection within the main building',
  datepickerPlaceholder: 'YYYY-MM-DD',
  imagePreview: {
    upload: 'Upload',
    cancel: 'Cancel',
    header: 'Image preview',
    noImages: 'No images to show',
    loadingImages: 'Loading...',
  },
  imagePreviewV2: {
    preview: 'Preview',
    addImages: 'Add images',
    close: 'Close',
    downloadAll: 'Download all',
    editImages: 'Edit images',
    manageImages: 'Manage images',
    done: 'Done',
    deleteImageQuestion: 'Delete image?',
    confirmDelete: 'Yes, delete',
    cancel: 'Cancel',
    confirmDeleteText: 'Are you sure you want to delete this image?',
    pleaseWait: 'Please wait...',
    download: 'Download',
    images: 'Images',
    imageDeleted: 'Image deleted',
    saved: 'Saved!',
    uploaded: 'Uploaded',
    noImagesAvailable: 'No images available',
    addImagesBelow: 'You can add images below!',
  },
  dateFormatError: 'You have filled in an incorrect date (YYYY-MM-DD).',
  tableConfiguration: {
    title: 'Configure table',
    cancel: 'Cancel',
    apply: 'Apply',
    showAllColumns: 'Show all columns',
  },
  ...months,
  ...weekdays,
  workSectionStatus: {
    EXECUTED: 'Executed',
    PLANNED: 'Planned',
    AWAITING_PLANNING: 'Awaiting planning',
    INCOMPLETE: 'Incomplete',
  },
  workSectionStatusTooltip: {
    EXECUTED: 'The work has been completed',
    PLANNED: 'The work has been scheduled but not yet completed',
    AWAITING_PLANNING: 'The work has not been planned yet',
    INCOMPLETE: 'Incomplete self-inspections while set as executed',
  },
  ductConnectionStatus: {
    NOT_CONNECTED: 'Not Connected',
  },
  fileUpload: {
    error: 'Files could not be uploaded',
    loadingImages: 'Loading images...',
  },
  select: 'Select ',
  tableFilter: {
    orderFilterssSectionHeader: ' selected filters',
    addFilterButton: 'Add filter',
    applyFilterButton: 'Apply filters',
    clearAllFiltersButton: 'Clear all filters',
    noFilteredOrders: 'No orders were found.',
    accessId: {
      existing: 'NetAdmin ID - Existing',
      notExisting: 'NetAdmin ID - Not existing',
    },
    plotDesign: {
      planned: 'Plot Design - Planned',
      awaitingPlanning: 'Plot Design - Awaiting planning',
      executed: 'Plot Design - Executed',
    },
    preinstallation: {
      planned: 'Preinstallation - Planned',
      awaitingPlanning: 'Preinstallation - Awaiting planning',
      executed: 'Preinstallation - Executed',
    },
    plotExcavation: {
      planned: 'Plot Excavation - Planned',
      awaitingPlanning: 'Plot Excavation - Awaiting planning',
      executed: 'Plot Excavation - Executed',
    },
    ductConnection: {
      connected: 'Duct Connected - Connected',
      notConnected: 'Duct Connected - Not Connected',
    },
    cableBlowing: {
      planned: 'Cable Blowing - Planned',
      awaitingPlanning: 'Cable Blowing - Awaiting planning',
      executed: 'Cable Blowing - Executed',
    },
    measuring: {
      planned: 'Splicing & Measuring - Planned',
      awaitingPlanning: 'Splicing & Measuring - Awaiting planning',
      executed: 'Splicing & Measuring - Executed',
    },
    commission: {
      planned: 'Commissioning - Planned',
      awaitingPlanning: 'Commissioning - Awaiting planning',
      executed: 'Commissioning - Executed',
    },
    perPage: 'Show per page: ',
  },
  feedbackAlert: {
    upload: {
      fileSuccess: 'Uploaded',
      success: 'Uploaded',
      error: 'Upload failed. Try again',
      signatureAlreadyExist: 'Signature already exists. Delete first.',
      couldNotConfirm: 'Could not confirm. Try again',
    },
    undoSelfInspection: {
      success: 'Undone',
      error: 'Failed to undo. Try again',
    },
    markAsNA: {
      success: 'Marked as N/A',
      error: 'Failed to mark as N/A. Try again',
    },
    save: {
      success: 'Saved',
      error: 'Failed to save. Try again',
    },
    remove: {
      success: 'Removed',
      error: 'Failed to remove. Try again',
    },
    get: {
      signatureError: 'Failed to fetch signature. Try again',
      downloadError: 'Download failed. Try again',
      preparingDownload: 'Preparing download, please wait...',
    },
  },
  signing: {
    header: 'Signing',
    back: 'Back',
    confirm: 'Confirm',
    CONTRACTOR: 'Contractor',
    CUSTOMER: 'Customer',
    signAsCONTRACTOR: 'Sign as contractor',
    signAsCUSTOMER: 'Sign as customer',
    infoText:
      'Add both signatures and confirm to complete signing the agreement.',
  },
  signingSummary: {
    customerInformation: 'Customer information',
    address: 'Address',
    propertyDesignation: 'Property designation',
    name: 'Full name',
    email: 'Email',
    mobileNumber: 'Mobile phone number',
    homeNumber: 'Home phone number',
    plotDesign: 'Plot Design',
    executedDate: 'Executed date',
    selfInspections: 'Self-inspections',
    notApplicable: 'Not-applicable',
    comment: 'Comment',
    confirming: 'Confirming...',
  },
  signingConfirmationModal: {
    headerTitle: 'Confirmed',
    return: 'Return to report',
    download: 'Download copy',
    title: 'All is set!',
    paragraph: 'Copy has been sent to email.',
    paragraphV2: 'Signed copy can be downloaded!',
  },
  signaturePad: {
    clear: 'Clear',
    close: 'Close',
    save: 'Save',
    remove: 'Remove signature',
  },
  signingCard: {
    title: 'Signing of Plot Design',
    information:
      'Perform all required self-inspections and enter executed date to enable signing.',
    startSigning: 'Start signing',
    newSigning: 'New signing',
  },
  signingErrorScreen: {
    reportDoesNotExist: 'This report does not exist',
    unableToStartSigning: 'Unable to start signing!',
    reportMissingData:
      'Report is missing executed date or has incomplete self-inspections.',
    goToReport: 'Go to report',
    signingCouldNotBeStarted: 'Signing could not be started!',
    refreshOrTryAgain: 'Refresh or try again later.',
    refreshPage: 'Refresh page',
  },
  rotateDeviceMessage: 'Rotate your device horizontally',
  copied: 'Copied',
  portConnectionStatus: {
    portConnection: 'Port connection',
    noMac: 'No valid MAC address or Serial number in Preinstallation',
    toPreinstallation: 'Go to Preinstallation',
    checkStatus: 'Check the port connection status.',
    checkConnection: 'Check connection',
    loadingState: 'Checking status. Please wait...',
    linking: 'Linking',
    notLinking: 'Not linking',
    installationDate: 'Installation date: ',
    checkAgain: 'Check again',
    debugMessage: 'Please troubleshoot and try again.',
  },
  pageSizepicker: { all: 'All' },
  tabletoolBar: {
    building: 'Buildings',
    deliveryPoint: 'Delivery Points',
    itemsPerPage: 'Items per page',
    search: 'Search',
    searchPlaceholder: 'Search',
  },
  installationReportingMduTable: {
    legend: {
      building: 'Building',
      deliveryPoint: 'Delivery Point',
    },
    constructionStatus: {
      PLANNED: 'Planned',
      HANDED_TO_CONSTRUCTION: 'Handed to construction',
      STARTED: 'Started',
      FINISHED: 'Finished',
      OBSTRUCTION: 'Obstruction',
      MIGRATION_ONGOING: 'Migration ongoing',
      MIGRATED: 'Migrated',
    },
    headers: {
      buildingName: 'Building name',
      status: 'Status',
      macAccessId: 'MAC & Access ID',
    },
    labels: {
      macAddress: 'MAC:',
      accessId: 'Access ID:',
    },
    status: {
      inProgress: 'In progress',
      approved: 'Approved',
      completed: 'Completed',
      underReview: 'Under review',
      notApplicable: 'Not applicable',
    },
  },
  installationReportingMduModal: {
    header: 'Installation Report',
  },
  buildingPageModal: {
    header: 'Installation Report Building',
    deliveryProject: 'Delivery Project',
    comment: 'Comment',
    commentPlaceholder: 'Type something...',
    commentPlaceholderPhase: 'Write a comment...',
    sectionNotApplicable: {
      markAsNotApplicable: 'Mark as not-applicable',
      reasonLabel: 'Add reason for N/A',
      reasonPlaceholder: 'Write a reason...',
      cancel: 'Cancel',
      tag: 'N/A',
      commentTitle: 'Comment',
      by: 'By',
      reactivate: 'Reactivate self-inspection',
      saveError: 'Could not update the not-applicable status of the section.',
    },
    optional: 'Optional',
    uploadedFileCount: 'Uploaded files: ',
    signing: {
      performedBy: 'Signing is performed by',
      deliveryContact: 'Delivery contact',
    },
    selfInspections: {
      plotDesign: {
        item1:
          'Verify that the plot design matches the installation conditions.',
        item1_1: 'Verify that required permits and approvals are in place.',
        item2: 'Mark the cable route and connection point.',
        item2_1: 'Verify that the marked route is clear for installation.',
        item3: 'Verify that required materials and equipment are available.',
        item4: 'Verify the planned customer equipment placement.',
        item6: 'Document any deviations from the plot design.',
        item7: 'Photograph the completed plot design.',
        item7_1: 'Verify that the photo documentation is complete.',
        item8: 'Verify that applicable safety requirements are met.',
        item10: 'Document other relevant information.',
      },
      preinstallation: {
        item1: 'Verify the CPE or ONT placement.',
        item2: 'Verify the power supply.',
        item3: 'Photograph the CPE or ONT placement.',
        item4: 'Photograph the cable route.',
        item5: 'Photograph the fiber outlet.',
        item6: 'Photograph the equipment label.',
      },
      plotExcavation: {
        item1: 'Photograph the excavation route.',
        item2: 'Photograph the excavation depth.',
        item2_1: 'Photograph the warning tape.',
        item3: 'Photograph the restored surface.',
      },
      ductConnection: {
        item1: 'Photograph the connected ducts.',
      },
      cableBlowing: {
        item1: 'Photograph the cable blowing installation.',
        item1_extra: 'Make sure cable markings are visible in the image.',
      },
    },
    notImplementedYet: 'Not implemented yet. Changes are not saved.',
  },
};
